import * as React from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';
import { EEstimationTargets } from '../../../../types';
import { ECurrentErrorField } from '../../../../actions/filters/types';
import { selectFilters } from '../../../../selectors';
import { useActions } from '../useActions';
import { useAnalytics } from '../useAnalytics';
import { trackAddressInputClick, trackAddressInputLaterSomeSeconds } from '../../../../analytics';
import { placeholders } from './constants/placeholders';
import { useHandleSuggestItemClick } from './useHandleSuggestItemClick';
var timerIdForAddressInputLaterSomeSeconds;
var timeoutAddressInputLater = 5000;
export var useAddressProps = function useAddressProps(_ref) {
  var isDesktop = _ref.isDesktop,
      targetPage = _ref.targetPage;

  var _useSelector = useSelector(selectFilters),
      address = _useSelector.address,
      errorTooltip = _useSelector.errorTooltip,
      addressGeoSuggest = _useSelector.addressGeoSuggest,
      estimationTarget = _useSelector.estimationTarget;

  var _useActions = useActions(),
      setAddress = _useActions.setAddress,
      getFlatAreasSuggest = _useActions.getFlatAreasSuggest,
      getAddressGeoSuggest = _useActions.getAddressGeoSuggest;

  var _useAnalytics = useAnalytics(),
      trackAddressChangeThrottled = _useAnalytics.trackAddressChangeThrottled;
  /** Если есть ошибка, отобразится над инпутом фильтра */


  var errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.address ? errorTooltip.errorText : ''; // eslint-disable-next-line react-hooks/exhaustive-deps

  var getGeoSuggestDebounced = React.useCallback(debounce(200, getAddressGeoSuggest), []);
  /** Обработчик ввода адреса */

  var onValueChange = React.useCallback(function (value) {
    clearTimeout(timerIdForAddressInputLaterSomeSeconds);
    trackAddressChangeThrottled(value, estimationTarget);
    setAddress({
      address: value
    });
    getGeoSuggestDebounced(value, targetPage);

    if (value) {
      timerIdForAddressInputLaterSomeSeconds = window.setTimeout(function () {
        return trackAddressInputLaterSomeSeconds(value, estimationTarget);
      }, timeoutAddressInputLater);
    }
  }, [getGeoSuggestDebounced, setAddress, trackAddressChangeThrottled, estimationTarget, targetPage]);
  /** Обработчик клика по итему в геосаджесте (список предложенных адресов) */

  var handleItemClick = useHandleSuggestItemClick(errorMessage, timerIdForAddressInputLaterSomeSeconds);
  /** Обработчик клика по инпуту */

  var onInputTagClick = React.useCallback(function (e) {
    if (e.target.tagName === 'INPUT') {
      trackAddressInputClick(estimationTarget);
    }
  }, [estimationTarget]);
  /** В момент 1й загрузки делается запрос за саджестом, если в сторе имеется адрес Квартиры */

  React.useEffect(function () {
    if (address && estimationTarget === EEstimationTargets.flat) {
      getFlatAreasSuggest(address);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return {
    value: address,
    errorMessage: errorMessage,
    addressGeoSuggest: addressGeoSuggest,
    onInputTagClick: onInputTagClick,
    onValueChange: onValueChange,
    onItemClick: handleItemClick,
    placeholder: placeholders[isDesktop ? 'desktop' : 'mobile'][estimationTarget]
  };
};